import dayjs from 'dayjs';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx-js-style';
import axiosClient from '@/api/axiosClient';
import _ from 'lodash';
import { toast } from 'react-toastify';
import { formatNumber } from './formatters';

export const formatDataTopicAnswer = (dataCharCore, key_word) => {
  const arrCore = dataCharCore?.split(',');
  let keyword = key_word?.trim();

  var arrayKeyWord = [];
  var arrNextKey = [];

  let isCheckTextKeyWord = true;

  for (var i = 0; i < keyword.length; i++) {
    var char = keyword[i];
    var charNext = keyword[i + 1] !== undefined ? keyword[i + 1] : '';

    var charMerge = char + charNext;
    if (_.includes(arrCore, charMerge)) {
      arrNextKey = [...arrNextKey, charNext];
      arrayKeyWord.push(charMerge);
    } else if (_.includes(arrCore, char)) {
      arrayKeyWord.push(char);
    } else if (!_.includes(arrNextKey, char)) {
      isCheckTextKeyWord = false;
    }
  }

  return {
    arrayKeyWord,
    isCheckTextKeyWord,
  };
};

export function getPathUrl(pathname) {
  let accumulatedPath = '';

  return pathname
    .split('/')
    .filter(Boolean)
    .map((segment) => {
      accumulatedPath += `/${segment}`;
      return {
        name: segment,
        url: accumulatedPath,
        isDynamicSegment: /^\d+$/.test(segment), // You can extend to match UUIDs
      };
    });
}

export function parseKeyword(str) {
  try {
    const parsed = JSON.parse(str);
    if (Array.isArray(parsed)) {
      return parsed.join('');
    }
  } catch (e) {
    // Do nothing if parsing fails
  }
  return str;
}

export function safeJSONParse(str) {
  try {
    return JSON.parse(str);
  } catch (e) {
    // clean string
    const sanitized = str
      ?.replace(/[\n\r\t]/g, '') // loại bỏ newlines, tabs
      ?.replace(/\\(?!["\\/bfnrtu])/g, '\\\\'); // escape bad \
    try {
      return JSON.parse(sanitized);
    } catch {
      return null;
    }
  }
}

export function exportToCSV(data, filename = 'export.csv') {
  const csv = [
    Object.keys(data[0]).join(','), // header row
    ...data.map((row) => Object.values(row).join(',')), // data rows
  ].join('\n');

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

// export function exportToExcel(
//   data,
//   options = {
//     fileName: 'download.xlsx',
//     sheetName: 'Sheet1',
//     columnMapping: null,
//     styled: true,
//   }
// ) {
//   if (!data || data.length === 0) {
//     toast.error('No data available to export');
//     return;
//   }

//   const processedData = options.columnMapping
//     ? data.map((row) =>
//         Object.entries(options.columnMapping).reduce((acc, [oldKey, newKey]) => {
//           if (row.hasOwnProperty(oldKey)) {
//             const val = row[oldKey];
//             acc[newKey] = typeof val === 'number' ? formatNumber(val) : val;
//           }
//           return acc;
//         }, {})
//       )
//     : data.map((row) =>
//         Object.entries(row).reduce((acc, [key, val]) => {
//           acc[key] = typeof val === 'number' ? formatNumber(val) : val;
//           return acc;
//         }, {})
//       );

//   const worksheet = XLSX.utils.json_to_sheet(processedData);
//   // If styling enabled
//   if (options.styled) {
//     const headers = Object.keys(processedData[0]);

//     // Range (to loop all cells)
//     const range = XLSX.utils.decode_range(worksheet['!ref']);

//     // Style all cells
//     for (let R = range.s.r; R <= range.e.r; R++) {
//       for (let C = range.s.c; C <= range.e.c; C++) {
//         const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
//         const cell = worksheet[cellAddress];
//         if (!cell) continue;

//         const isEvenCol = C % 2 === 0;

//         cell.s = {
//           ...cell.s,
//           alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
//           border: {
//             top: { style: 'thin', color: { rgb: '999999' } },
//             bottom: { style: 'thin', color: { rgb: '999999' } },
//             left: { style: 'thin', color: { rgb: '999999' } },
//             right: { style: 'thin', color: { rgb: '999999' } },
//           },
//           ...(isEvenCol && R > 0
//             ? {
//                 fill: {
//                   type: 'pattern',
//                   patternType: 'solid',
//                   fgColor: { rgb: 'F2F2F2' },
//                 },
//               }
//             : {}),
//         };
//       }
//     }

//     // Header style
//     headers.forEach((_, colIdx) => {
//       const cellAddress = XLSX.utils.encode_cell({ r: 0, c: colIdx });
//       if (worksheet[cellAddress]) {
//         worksheet[cellAddress].s = {
//           font: { bold: true, color: { rgb: 'FFFFFF' } },
//           fill: { fgColor: { rgb: '4F81BD' } },
//           alignment: { horizontal: 'center', vertical: 'center' },
//           border: {
//             top: { style: 'thin', color: { rgb: '999999' } },
//             bottom: { style: 'thin', color: { rgb: '999999' } },
//             left: { style: 'thin', color: { rgb: '999999' } },
//             right: { style: 'thin', color: { rgb: '999999' } },
//           },
//         };
//       }
//     });
//   }

//   // Auto column widths (always applied)
//   const headers = Object.keys(processedData[0]);
//   const allRows = [headers, ...processedData.map((row) => Object.values(row))];
//   worksheet['!cols'] = headers.map((_, colIdx) => {
//     const maxLength = allRows.reduce((max, row) => {
//       const value = row[colIdx] ? String(row[colIdx]) : '';
//       return Math.max(max, value.length);
//     }, 10);
//     return { wch: maxLength + 2 };
//   });

//   // Create workbook + save
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName);

//   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), options.fileName);
// }

export function exportToExcel(
  data,
  options = {
    fileName: 'download.xlsx',
    sheetName: 'Sheet1',
    columnMapping: null,
    styled: true,
    groupedHeaders: null, // New option for grouped headers
  }
) {
  if (!data || data.length === 0) {
    toast.error('No data available to export');
    return;
  }

  const processedData = options.columnMapping
    ? data.map((row) =>
        Object.entries(options.columnMapping).reduce((acc, [oldKey, newKey]) => {
          if (row.hasOwnProperty(oldKey)) {
            const val = row[oldKey];
            // acc[newKey] = typeof val === 'number' ? formatNumber(val) : val;
            acc[newKey] = val;
          }
          return acc;
        }, {})
      )
    : data.map((row) =>
        Object.entries(row).reduce((acc, [key, val]) => {
          acc[key] = typeof val === 'number' ? formatNumber(val) : val;
          return acc;
        }, {})
      );

  // Create worksheet with data (this will be moved down to accommodate headers)
  let worksheet;
  let headerRowCount = 1;

  if (options.groupedHeaders) {
    // Create blank worksheet
    worksheet = XLSX.utils.aoa_to_sheet([]);

    // Calculate header structure
    const { headerRows, merges } = createGroupedHeaders(options.groupedHeaders);
    headerRowCount = headerRows.length;

    // Add header rows
    headerRows.forEach((row, rowIndex) => {
      row.forEach((cellValue, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({ r: rowIndex, c: colIndex });
        worksheet[cellAddress] = { v: cellValue, t: 's' };
      });
    });

    // Add data rows (starting after headers)
    const dataHeaders = Object.keys(processedData[0]);
    processedData.forEach((row, rowIndex) => {
      dataHeaders.forEach((header, colIndex) => {
        const cellAddress = XLSX.utils.encode_cell({
          r: headerRowCount + rowIndex,
          c: colIndex,
        });
        worksheet[cellAddress] = { v: row[header], t: typeof row[header] === 'number' ? 'n' : 's' };
      });
    });

    // Set worksheet range
    const range = {
      s: { c: 0, r: 0 },
      e: { c: dataHeaders.length - 1, r: headerRowCount + processedData.length - 1 },
    };
    worksheet['!ref'] = XLSX.utils.encode_range(range);

    // Add merges for grouped headers
    worksheet['!merges'] = merges;
  } else {
    // Original behavior - simple headers
    worksheet = XLSX.utils.json_to_sheet(processedData);
  }

  // Apply styling
  if (options.styled) {
    applyExcelStyling(worksheet, processedData, headerRowCount, options.groupedHeaders);
  }

  // Auto column widths
  const headers = Object.keys(processedData[0]);
  const allRows = [headers, ...processedData.map((row) => Object.values(row))];
  worksheet['!cols'] = headers.map((_, colIdx) => {
    const maxLength = allRows.reduce((max, row) => {
      const value = row[colIdx] ? String(row[colIdx]) : '';
      return Math.max(max, value.length);
    }, 10);
    return { wch: Math.max(maxLength + 2, 12) }; // Minimum width of 12
  });

  // Create workbook + save
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, options.sheetName);

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  saveAs(new Blob([excelBuffer], { type: 'application/octet-stream' }), options.fileName);
}

// Helper function to create grouped headers structure
function createGroupedHeaders(groupedHeaders) {
  const headerRows = [];
  const merges = [];

  // Determine the maximum depth
  let maxDepth = 1;
  groupedHeaders.forEach((group) => {
    if (group.children && group.children.length > 0) {
      maxDepth = Math.max(maxDepth, 2);
      group.children.forEach((subGroup) => {
        if (subGroup.children && subGroup.children.length > 0) {
          maxDepth = Math.max(maxDepth, 3);
        }
      });
    }
  });

  // Initialize header levels
  const headerLevels = Array.from({ length: maxDepth }, () => ['Charge Time']);

  let colIndex = 1;

  groupedHeaders.forEach((group) => {
    const groupStartCol = colIndex;

    // CASE 1: group has children
    if (group.children && group.children.length > 0) {
      group.children.forEach((subGroup) => {
        const subGroupStartCol = colIndex;

        if (subGroup.children && subGroup.children.length > 0) {
          // 3-level structure
          subGroup.children.forEach((col) => {
            headerLevels[2].push(col.title);
            colIndex++;
          });

          const subGroupEndCol = colIndex - 1;
          for (let i = subGroupStartCol; i <= subGroupEndCol; i++) {
            headerLevels[1].push(subGroup.title);
          }

          if (subGroupEndCol > subGroupStartCol) {
            merges.push({
              s: { r: 1, c: subGroupStartCol },
              e: { r: 1, c: subGroupEndCol },
            });
          }
        } else {
          // 2-level
          headerLevels[1].push(subGroup.title);
          if (maxDepth >= 3) headerLevels[2].push('');
          colIndex++;
        }
      });

      // Merge main group horizontally
      const groupEndCol = colIndex - 1;
      for (let i = groupStartCol; i <= groupEndCol; i++) {
        headerLevels[0].push(group.title);
      }
      if (groupEndCol > groupStartCol) {
        merges.push({
          s: { r: 0, c: groupStartCol },
          e: { r: 0, c: groupEndCol },
        });
      }
    } else {
      // CASE 2: no children → merge vertically
      headerLevels[0].push(group.title);

      // Fill empty cells for lower levels
      for (let i = 1; i < maxDepth; i++) {
        headerLevels[i].push('');
      }

      // Vertically merge this single header across all rows
      if (maxDepth > 1) {
        merges.push({
          s: { r: 0, c: groupStartCol },
          e: { r: maxDepth - 1, c: groupStartCol },
        });
      }

      colIndex++;
    }
  });

  // Merge "Charge Time" vertically too
  if (maxDepth > 1) {
    merges.push({
      s: { r: 0, c: 0 },
      e: { r: maxDepth - 1, c: 0 },
    });
  }

  return { headerRows: headerLevels, merges };
}

// Helper function to apply styling
function applyExcelStyling(worksheet, processedData, headerRowCount, groupedHeaders) {
  const range = XLSX.utils.decode_range(worksheet['!ref']);

  // Style all cells
  for (let R = range.s.r; R <= range.e.r; R++) {
    for (let C = range.s.c; C <= range.e.c; C++) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellAddress];
      if (!cell) continue;

      const isHeader = R < headerRowCount;
      const isEvenCol = C % 2 === 0;

      // Base cell style
      cell.s = {
        alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        border: {
          top: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
          left: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
        },
      };

      if (isHeader) {
        // Header styles
        if (R === 0) {
          // Main group headers (Level 0)
          cell.s.font = { bold: true, color: { rgb: 'FFFFFF' }, size: 12 };
          cell.s.fill = { fgColor: { rgb: '4472C4' } }; // Dark blue
        } else if (R === 1) {
          // Sub-group headers (Level 1)
          cell.s.font = { bold: true, color: { rgb: 'FFFFFF' }, size: 11 };
          cell.s.fill = { fgColor: { rgb: '70AD47' } }; // Green
        } else if (R === 2) {
          // Individual column headers (Level 2)
          cell.s.font = { bold: true, color: { rgb: '000000' }, size: 10 };
          cell.s.fill = { fgColor: { rgb: 'E7E6E6' } }; // Light gray
        }
      } else {
        // Data row styles
        if (isEvenCol) {
          cell.s.fill = {
            fgColor: { rgb: 'F2F2F2' }, // Very light gray for alternating columns
          };
        }

        // Number formatting for data cells
        if (typeof cell.v === 'number' && cell.v > 0) {
          cell.s.font = { color: { rgb: '000000' } };
        }
      }
    }
  }
}

export async function saveFile(url, fileName, config = {}) {
  try {
    const response = await axiosClient.get(url, {
      ...config,
      responseType: 'blob',
    });

    saveAs(response, fileName);
  } catch (error) {
    // Optionally handle error globally or rethrow
    console.error('File download failed:', error);
    throw error;
  }
}

export const defaultPresets = [
  { label: 'Current', value: [dayjs().startOf('month'), dayjs()] },
  { label: 'Last 7 Days', value: [dayjs().add(-7, 'day'), dayjs()] },
  { label: 'Last 14 Days', value: [dayjs().add(-14, 'day'), dayjs()] },
  { label: 'Last 1 Month', value: [dayjs().add(-30, 'day'), dayjs()] },
];
